const { default: push } = require("../../datalayer/utils/push");

(function (window) {
    if ($('.video-snippet').length == 0) return;
    
    var Bunge = Bunge || {};

    window.onYouTubeIframeAPIReady = function(){
        Bunge.youTubeVideo.onYouTubeIframeAPIReady;
    }

    Bunge.youTubeVideos = [];

    Bunge.youTubeVideo = function(id, uid) {
        const youTubeId = id;
        const uniqueId = uid;
        const youTubeApiUrl = 'https://www.youtube.com/iframe_api';
        const youTubeScriptId = `youtube-script-${youTubeId}-${uniqueId}`;
        const youTubePlayerId = `youtube-iframe-${youTubeId}-${uniqueId}`;
        let player = {};
        
        function loadApi() {
            var tag = document.createElement("script");
            tag.id = youTubeScriptId;
            tag.src = youTubeApiUrl;
            tag.async = true;
            document.body.appendChild(tag);
        };
        
        function onYouTubeIframeAPIReady() {
            window.YT = window.YT || {};
            if (typeof window.YT.Player !== 'function') return;

            player = new window.YT.Player(youTubePlayerId, {
                events: {
                    'onStateChange': onPlayerStateChange,
                    'onError': onPlayerError,
                }
            });
            Bunge.youTubeVideos.push(player);
        };
        
        function onPlayerStateChange(e) {
            const youTubeId = e.target.playerInfo.videoData.video_id;
            const playerState = e.data;
            const currentTime = e.target.getCurrentTime();
            let currentState = 'UNSTARTED';

            switch (playerState) {
                case YT.PlayerState.PLAYING:
                    currentState = 'PLAYING';
                    break;
                case YT.PlayerState.PAUSED:
                    currentState = 'PAUSED';
                    break;
                case YT.PlayerState.ENDED:
                    currentState = 'ENDED';
                    break;
            }

            push({
                'event': 'videoEvent',
                'videoId': youTubeId,
                'videoAction': currentState,
                'currentTime': currentTime,
            });
        };
        
        function onPlayerError(e) {
            console.log( "youtube: " + e.target.src + " - " + e.data);
        };

        loadApi();
        window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady.bind(this);
    }

    let videos = document.querySelectorAll('[data-youtube]');
    videos.forEach((video, i) => {
        const id = video.getAttribute('data-youtube');
        const uid = `${id}-${i}`;
        const youTubePlayerHtml = `<img class="video-snippet__thumbnail" alt="" src="https://img.youtube.com/vi/${id}/maxresdefault.jpg"><br>${video.textContent}`;
        var youTubeVideo;
        video.setAttribute('role', 'button');
        video.innerHTML += youTubePlayerHtml;

        video.addEventListener('click', function handleClick(event) {
            const player = document.createElement('div');
            const playerHtml = `<iframe id="youtube-iframe-${id}-${uid}" width="100%" height="100%" src="https://www.youtube.com/embed/${id}?autoplay=1&enablejsapi=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
            player.innerHTML = playerHtml;
            video.replaceWith(player);
            youTubeVideo = new Bunge.youTubeVideo(id, uid);
            window.onYouTubeIframeAPIReady();
        });
    });

    let videoVims = document.querySelectorAll('[data-vimeo]');
    if(videoVims.length == 0) return;
    
    const vimeoApiUrl = 'https://player.vimeo.com/api/player.js';

    var tag = document.createElement("script");
    tag.id = 'vimeo-script';
    tag.src = vimeoApiUrl;
    tag.async = true;
    document.body.appendChild(tag);

    let videoVim = 1;
    videoVims.forEach((videoVim, i) => {
        let id = videoVim.getAttribute('data-vimeo');
        const uid = `${id}-${i}`;
        const playerId = `vimeo-${id}-${uid}`;
        const playerSrc = `https://player.vimeo.com/video/${id}?autoplay=1`;
        const playerHtml = `<img class="video-snippet__thumbnail" alt="" src="https://vumbnail.com/${id}.jpg"><br>${videoVim.textContent}`;
        videoVim.setAttribute('role', 'button');
        videoVim.innerHTML += playerHtml;

        videoVim.addEventListener('click', function handleClick(event) {
            let vimeoIframe = document.createElement('iframe');
            vimeoIframe.id = playerId;
            vimeoIframe.src = playerSrc;
            vimeoIframe.width = '100%';
            vimeoIframe.height = '100%';
            vimeoIframe.title = 'vimeo video player';
            vimeoIframe.frameborder = 0;
            vimeoIframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
            vimeoIframe.allowfullscreen = true;

            var vimeoPlayer = new window.Vimeo.Player(vimeoIframe);

            vimeoPlayer.on('play', (e) => {
                push({
                    'event': 'videoEvent',
                    'videoId': id,
                    'videoAction': 'PLAY',
                    'currentTime': e.seconds,
                });
            })
            
            vimeoPlayer.on('ended', (e) => {
                push({
                    'event': 'videoEvent',
                    'videoId': id,
                    'videoAction': 'ENDED',
                    'currentTime': e.seconds,
                });
            })
            
            vimeoPlayer.on('pause', (e) => {
                push({
                    'event': 'videoEvent',
                    'videoId': id,
                    'videoAction': 'PAUSE',
                    'currentTime': e.seconds,
                });
            });

            if (videoVim.parentElement.classList.contains('-fullwidth')) {
                let overlay = document.querySelector(
                    '.video-snippet__video-container'
                );
                if (overlay) {
                    videoVim.parentElement.classList.add('active');
                    let outerOverlay = document.querySelector(
                        '.video-snippet__outer-overlay'
                    );
                    let closeButton = document.querySelector(
                        '.video-snippet__close-button'
                    );
                    if (closeButton) {
                        closeButton.classList.add('active');
                    }
                    outerOverlay.classList.add('active');
                    if (overlay.children.length === 0) {
                        overlay.append(vimeoIframe);
                    }
                }
            } else {
                let player = document.createElement('div');
                player.append(vimeoIframe);
                videoVim.replaceWith(player);
            }
        });
    });

    let closeButton = document.querySelector('.video-snippet__close-button');
    if (closeButton) {
        closeButton.addEventListener('click', function handleClick(event) {
            closeModal();
        });
    }

    function closeModal() {
        document
            .querySelector('.video-snippet.active')
            .classList.remove('active');
        document.querySelector('.video-snippet__video-container').innerHTML =
            '';
        let outerOverlay = document.querySelector(
            '.video-snippet__outer-overlay.active'
        );
        outerOverlay.classList.remove('active');
        let closeButton = document.querySelector(
            '.video-snippet__close-button'
        );
        if (closeButton) {
            closeButton.classList.remove('active');
        }
    }
})(window);